// extracted by mini-css-extract-plugin
export var box = "_8j-1";
export var checkboxRow = "_8j-8";
export var checked = "_8j-2";
export var descriptionSpacer = "_8j-a";
export var disabled = "_8j-3";
export var icon = "_8j-6";
export var input = "_8j-0";
export var labelSpacer = "_8j-9";
export var medium = "_8j-5";
export var small = "_8j-4";
export var text = "_8j-7";